export const bedroomsFilterMap = {
  0: "S",
};
